import { render, staticRenderFns } from "./AwardPicture.vue?vue&type=template&id=3b8580dc&scoped=true&"
import script from "./AwardPicture.vue?vue&type=script&lang=js&"
export * from "./AwardPicture.vue?vue&type=script&lang=js&"
import style0 from "./AwardPicture.vue?vue&type=style&index=0&id=3b8580dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8580dc",
  null
  
)

export default component.exports